import makeApiCall from "../master/axiosIndex";

// Base path: /gateWay/tms/tender-dashboard
// (the `/gateWay` prefix is already baked into REACT_APP_API_LOGIN_URL)
const BASE = "/tms/tender-dashboard";

export interface TenderDashboardBaseParams {
  orgIds?: string | number;
  startDate?: string;
  endDate?: string;
  year?: string | number;
  page?: number;
  pagesize?: number;
}

const tenderDashboardApis = {
  getTenderSummary: (params: TenderDashboardBaseParams): Promise<any> =>
    makeApiCall<any>({
      url: `${BASE}/tender-summary`,
      method: "get",
      params,
    }),

  getRiskIndicators: (params: TenderDashboardBaseParams): Promise<any> =>
    makeApiCall<any>({
      url: `${BASE}/risk-indicators`,
      method: "get",
      params,
    }),

  getMarketEngagementTrend: (params: TenderDashboardBaseParams): Promise<any> =>
    makeApiCall<any>({
      url: `${BASE}/market-engagement-trend`,
      method: "get",
      params,
    }),

  getTopAwardees: (params: TenderDashboardBaseParams): Promise<any> =>
    makeApiCall<any>({
      url: `${BASE}/top-awardees`,
      method: "get",
      params,
    }),

  getTopEvaluators: (params: TenderDashboardBaseParams): Promise<any> =>
    makeApiCall<any>({
      url: `${BASE}/top-evaluators`,
      method: "get",
      params,
    }),

  getLiveTendersLowResponses: (params: TenderDashboardBaseParams): Promise<any> =>
    makeApiCall<any>({
      url: `${BASE}/live-tenders-low-responses`,
      method: "get",
      params,
    }),

  getEvaluationCompletionByTender: (
    params: TenderDashboardBaseParams
  ): Promise<any> =>
    makeApiCall<any>({
      url: `${BASE}/evaluation-completion-by-tender`,
      method: "get",
      params,
    }),
};

export default tenderDashboardApis;
